module.exports = __webpack_public_path__ + "static/soehne-web-leicht-5c931f5d97746b0ba2506eb55af315bf.woff";